import { IconNavHome, IconNavStudy, IconNavVocabulary, IconNavExam } from "@/assets/icons";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { NavItem } from "@/components/layout/MobileLayout/MobileLayout.types";
import { AppRoutes } from "@/routes/config";

/**
 * NOTE: The requirement here is that the `label` field for each bottom navigation item must remain in Japanese and should not be translated to other languages.
 */
export const BOTTOM_NAV_ITEMS: NavItem[] = [
  { icon: IconNavHome, label: "ホーム", path: AppRoutes.home },
  { icon: IconNavStudy, label: "もんだい", path: AppRoutes.study },
  { icon: IconNavVocabulary, label: "たんご", path: AppRoutes.vocabularyCategoryList },
  { icon: IconNavExam, label: "もし", path: AppRoutes.mockExam },
  { icon: MoreHorizIcon, label: "そのた", path: AppRoutes.more },
];
